import { ConstantPool } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { couldStartTrivia } from 'typescript';
import { Notificationpreference } from './model/notificationpreference';
import { ProjectnotificationService } from './service/projectnotification.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectnotification',
  templateUrl: './projectnotification.component.html',
  styleUrls: ['./projectnotification.component.css']
})
export class ProjectnotificationComponent implements OnInit {
  @Input() projectId:string;
  @Input() defaultSettings:boolean = false;
  notificationList:Notificationpreference[];
  noNotificationsMsg:string;
  commentaddPref:Notificationpreference;
  commenttaggedPref:Notificationpreference;
  taskdonePref:Notificationpreference;
  taskduePref:Notificationpreference;
  taskstartPref:Notificationpreference;
  taskaddPref:Notificationpreference;

  constructor(private pns:ProjectnotificationService) { }

  ngOnInit(): void {
    this.noNotificationsMsg = "No notification preferences for this project. Check if you are added to the project or try to re-add."
    
    // Use the projectId input if provided, otherwise use current project
    const effectiveProjectId = this.projectId || SessionHelper.getCurrentProject();
    //console.log('project id from projnot', effectiveProjectId, 'defaultSettings:', this.defaultSettings);
    
    this.pns.getNotificationPreferences(effectiveProjectId, SessionHelper.getUserSub()).pipe(untilDestroyed(this)).subscribe(nplist =>{
      this.notificationList = nplist.filter(x => x.personId == SessionHelper.getUserSub());
     //console.log('Notification preference list',nplist);
     //console.log('Filtered Notification preference list',this.notificationList);
      this.commentaddPref = this.notificationList.find(x => x.preference == 'commentadd') ? this.notificationList.find(x => x.preference == 'commentadd') :  {
        preferencevalue:false,
        preference:"commentadd",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };
      this.commenttaggedPref = this.notificationList.find(x => x.preference == 'commenttagged') ? this.notificationList.find(x => x.preference == 'commenttagged') : {
        preferencevalue:false,
        preference:"commenttagged",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };
      this.taskdonePref = this.notificationList.find(x => x.preference == 'taskdone') ? this.notificationList.find(x => x.preference == 'taskdone') : {
        preferencevalue:false,
        preference:"taskdone",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };
      this.taskduePref = this.notificationList.find(x => x.preference == 'taskdue')  ? this.notificationList.find(x => x.preference == 'taskdue') : {
        preferencevalue:false,
        preference:"taskdue",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };
      this.taskstartPref = this.notificationList.find(x => x.preference == 'taskstart') ? this.notificationList.find(x => x.preference == 'taskstart') : {
        preferencevalue:false,
        preference:"taskstart",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };
      this.taskaddPref = this.notificationList.find(x => x.preference == 'taskadd') ? this.notificationList.find(x => x.preference == 'taskadd') : {
        preferencevalue:false,
        preference:"taskadd",
        personId: SessionHelper.getUserSub(),
        projectId: effectiveProjectId,
        lastupdate: new Date()
      };


      //console.log('Notification preference list',this.notificationList);
    })

  }
  setNotificationPreference(event,notf:Notificationpreference){
    //console.log('event',event.srcElement.checked);
    notf.preferencevalue = event.srcElement.checked;
    this.pns.setNotificationPreferences(notf).pipe(untilDestroyed(this)).subscribe(result => {
      //console.log('Response from service',result);
    });


  }

}
